export default __webpack_public_path__ + "static/Harry_Hol_1-ce8ad6d7cddddcc4698f45966c1f728a.jpg";